import { useState } from 'react';
import { Modal } from './Modals.jsx';

// ร่างข้อความทวง — copy ไปส่งผ่าน Super Chat / อีเมล; log nudge_sent
export function NudgeModal({ draft, requirement, onClose, onSent }) {
  const [text, setText] = useState(draft.body);
  const [copied, setCopied] = useState(false);
  const [busy, setBusy] = useState(false);

  const copy = async () => {
    try { await navigator.clipboard.writeText(text); setCopied(true); setTimeout(() => setCopied(false), 1500); }
    catch { /* clipboard อาจถูกบล็อก */ }
  };
  const markSent = async (channel) => {
    setBusy(true);
    try { await onSent?.(channel, text); onClose(); } finally { setBusy(false); }
  };

  const internal = draft.audience === 'internal';
  const sub = internal
    ? 'งานฝั่งเรา — ไม่ใช่ทวง supplier'
    : draft.audience === 'broker'
      ? `ร่างข้อความถึง broker (${draft.to}) — แจ้งให้เดินเรื่องในไทย`
      : `ร่างข้อความถึง supplier (${draft.to}, ${draft.lang === 'th' ? 'ไทย' : 'อังกฤษ'}) — แก้ได้ก่อนส่ง`;

  return (
    <Modal title={draft.title} sub={sub} onClose={onClose} wide>
      {internal ? (
        <>
          <div className="nudge-internal">{draft.body}</div>
          <div className="mfoot">
            <button className="btn2" onClick={onClose}>ปิด</button>
            <button className="btn1" disabled={busy} onClick={() => markSent('internal')}>บันทึกว่ารับทราบแล้ว</button>
          </div>
        </>
      ) : (
        <>
          <textarea className="nudge-text" value={text} onChange={e => setText(e.target.value)} rows={7}/>
          <div className="nudge-foot">
            <button className="btn2" onClick={copy}>{copied ? '✓ คัดลอกแล้ว' : 'คัดลอกข้อความ'}</button>
            <span className="nudge-hint">วางใน Super Chat / อีเมล ส่งหา supplier แล้วกดปุ่มขวา</span>
            <button className="btn1" disabled={busy} onClick={() => markSent('manual')}>
              {busy ? 'บันทึก…' : 'ส่งแล้ว — บันทึก'}
            </button>
          </div>
        </>
      )}
    </Modal>
  );
}
